module.exports = __webpack_public_path__ + "img/xukezheng1.82fed7a2.jpg";